import classNames from "classnames";
import type { ReactNode } from "react";
import styles from "./Notification.module.scss";

const Notification = ({
  chat,
  className,
  variant = "info",
  bordered,
  children,
}: NotificationProps) => {
  const classes = classNames(styles.notification, styles[variant], className, {
    [styles.bordered]: bordered,
    [styles.chat]: chat,
  });

  return <div className={classes}>{children}</div>;
};

type NotificationProps = {
  chat?: boolean;
  bordered?: boolean;
  variant?: "info" | "success" | "warning" | "danger";
  className?: string;
  children?: ReactNode;
};

export default Notification;
